/**
 * External link directive
 * Adds target="_blank" and rel="noopener" to links
 *
 * @usage
 *
 * On a standard link: <a href="someUrl" v-external> Link </a>
 * On a vuetify element with a link inside: <list-tile :href="someUrl" v-external> Link </list-tile>
 */

export const external = {
  bind (el, binding) {
    const child = el.childNodes && el.childNodes[0]
    // Enable if no explicit value is present or truthy
    const enabled = typeof binding.value === 'undefined' || binding.value
    if (el.tagName !== 'A' && (child && child.tagName !== 'A')) {
      throw 'v-external element must be a link or have a child link'
    }
    if (typeof enabled !== 'boolean') {
      throw 'v-external value must be a boolean'
    }
    if (enabled) {
      const element = el.tagName === 'A' ? el : child
      element.rel = 'noopener'
      element.target = '_blank'
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/directives/external.js